import { render, staticRenderFns } from "./TeacherConv.vue?vue&type=template&id=7bfb07cc&scoped=true"
import script from "./TeacherConv.vue?vue&type=script&lang=ts"
export * from "./TeacherConv.vue?vue&type=script&lang=ts"
import style0 from "./TeacherConv.vue?vue&type=style&index=0&id=7bfb07cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb07cc",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QBar,QChip,QBtn,QIcon});qInstall(component, 'directives', {Ripple});
